import { canvassHousesGateway } from "@/gateways/canvassesGateway";
import { useMutation, useQuery, useQueryClient } from "@tanstack/vue-query";
import type { CanvassHouse } from "./types";

export function useGetCanvassHouses(canvassId: string) {
  const query = useQuery({
    queryKey: ["canvassHouses", canvassId],
    queryFn: () => canvassHousesGateway.listCanvassesHouses(canvassId),
  });

  return {
    ...query,
    getCanvassHousesStatus: query.status,
    canvassHouses: query.data,
  };
}

export function useGetCanvassHouse(canvassId: string, houseId: number) {
  const query = useQuery({
    queryKey: ["canvassHouse", canvassId, houseId],
    queryFn: () => canvassHousesGateway.getCanvassHouse(canvassId, houseId),
  });

  return {
    ...query,
    getCanvassHouseStatus: query.status,
    canvassHouse: query.data,
  };
}

export function useUpdateHouse(canvassId: string) {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: (canvassHouse: CanvassHouse) =>
      canvassHousesGateway.updateHouse(canvassId, canvassHouse),
    onSuccess: (_data, canvassHouse) => {
      queryClient.invalidateQueries({ queryKey: ["canvassHouses", canvassId] });
      queryClient.invalidateQueries({
        queryKey: ["canvassHouse", canvassId, canvassHouse.id],
      });
    },
  });

  return {
    ...mutation,
    updateHouseStatus: mutation.status,
    updateHouse: mutation.mutate,
  };
}

export function useUpdateCanvassHouse(canvassId: string) {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    scope: { id: `updateCanvassHouse-${canvassId}` },
    mutationFn: (canvassHouse: CanvassHouse) =>
      canvassHousesGateway.updateCanvassHouse(canvassId, canvassHouse),
    onSuccess: (_data, canvassHouse) => {
      queryClient.invalidateQueries({ queryKey: ["canvassHouses", canvassId] });
      queryClient.invalidateQueries({
        queryKey: ["canvassHouse", canvassId, canvassHouse.id],
      });
    },
  });

  return {
    ...mutation,
    updateCanvassHouseStatus: mutation.status,
    updateCanvassHouse: mutation.mutate,
  };
}
